// src/components/cofounder/CoFounderInput.js
import React, { useState, useRef, useEffect } from 'react';
import { Send } from 'lucide-react';

const CoFounderInput = ({ onSend, isLoading, placeholder = 'Ask your coFounder...' }) => {
  const [input, setInput] = useState('');
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = Math.min(textareaRef.current.scrollHeight, 120) + 'px';
    }
  }, [input]);

  const handleSubmit = () => {
    if (!input.trim() || isLoading) return;
    onSend(input.trim());
    setInput('');
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="flex items-end gap-2 p-3 border-t border-gray-200 bg-white">
      <textarea
        ref={textareaRef}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={isLoading}
        rows={1}
        className="flex-1 resize-none rounded-xl border border-gray-200 px-3 py-2 text-sm
          focus:outline-none focus:border-[#190192] focus:ring-1 focus:ring-[#190192]
          disabled:bg-gray-50 disabled:text-gray-400
          placeholder-gray-400"
      />
      <button
        onClick={handleSubmit}
        disabled={!input.trim() || isLoading}
        className="p-2 rounded-xl bg-[#190192] text-white hover:bg-[#0f0075]
          disabled:bg-gray-300 disabled:cursor-not-allowed
          transition-colors flex-shrink-0"
      >
        <Send size={16} />
      </button>
    </div>
  );
};

export default CoFounderInput;
